/* global axios */
import ApiClient from './ApiClient';

// Inbox Archive (Phase 1C) — read-only viewer API client.
// Write actions (archive / unarchive / permanent delete) stay on the existing
// inboxes API client so the lifecycle code lives in one place.
class ArchivesAPI extends ApiClient {
  constructor() {
    super('archives', { accountScoped: true });
  }

  conversations(inboxId, { page = 1, perPage = 25, q = '' } = {}) {
    return axios.get(`${this.url}/${inboxId}/conversations`, {
      params: { page, per_page: perPage, q },
    });
  }

  messages(inboxId, conversationId, { page = 1, perPage = 50 } = {}) {
    return axios.get(
      `${this.url}/${inboxId}/conversations/${conversationId}/messages`,
      { params: { page, per_page: perPage } }
    );
  }

  // Phase 1D — bulk export. Returns the raw URL so callers can trigger a
  // download via window.location or anchor click; the Rails endpoint sends
  // the file as a binary attachment with the proper Content-Disposition.
  exportPhonesUrl(inboxId) {
    return `${this.url}/${inboxId}/export_phones`;
  }

  exportChatsUrl(inboxId) {
    return `${this.url}/${inboxId}/export_chats`;
  }

  // Phase 1D Option C — CSV chat history (replaces the JSON button in UI).
  // The JSON variant above stays available for programmatic consumers.
  exportChatsCsvUrl(inboxId) {
    return `${this.url}/${inboxId}/export_chats_csv`;
  }

  // Phase 1D Option B — wide CSV with custom_attributes, labels, identifier.
  exportContactsFullUrl(inboxId) {
    return `${this.url}/${inboxId}/export_contacts_full`;
  }

  // Phase 1E — irreversible permanent delete. Backend enforces:
  // cooldown 24h, name match, password verification.
  permanentDelete(inboxId, { inboxName, password, reason }) {
    return axios.post(`${this.url}/${inboxId}/permanent_delete`, {
      permanent_delete: {
        inbox_name: inboxName,
        password: password,
        reason: reason,
      },
    });
  }
}

export default new ArchivesAPI();
